import { useAppSelector } from 'app/hooks';
import AlertModal from 'components/common/AlertModal';
import FeatureTitleBar from 'components/common/FeatureTitleBar';
import { selectIsEditMode } from 'features/common/editModeSlice';
import { DisplayControlGroup } from 'features/DisplayControlGroup/models';
import { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import FormDetail from './components/FormDetail';
import service from './services';

interface DetailProps {
  id: string;
  show: boolean;
  handleCloseModalEdit: () => void;
  dataTable: any[];
  setDataTable: (dataTable: DisplayControlGroup[]) => void;
  isAdd: boolean;
  showGlobalModal: (content: () => JSX.Element) => void;
}

const Detail = ({ id, show, handleCloseModalEdit, dataTable, setDataTable, isAdd, showGlobalModal }: DetailProps) => {
  const { t } = useTranslation();
  const [object, setObject] = useState<any>(undefined);

  // selectors
  const isEditMode = useAppSelector(selectIsEditMode);

  useEffect(() => {
    if (!isAdd && id) {
      const getDisplayControlGroup = async (id: string) => {
        try {
          const res = await service.getDisplayControlGroup(id);
          setObject(res.data);
        } catch {
          showGlobalModal &&
            showGlobalModal(() => (
              <AlertModal
                title={t('DisplayControlGroup.Validator.error')}
                message={t('DisplayControlGroup.Validator.500')}
              />
            ));
        }
      };
      getDisplayControlGroup(id);
    } else {
      setObject({
        id: 0,
        name: '',
        display_name: '',
        display_name_ja: '',
        display_name_en: '',
        display_name_vi: '',
        display_name_ko: '',
        display_name_zh_hant: '',
        display_name_zh_hans: '',
        note: '',
        delete_flg: false,
        code: '',
      });
    }
  }, [id, isAdd, showGlobalModal, t]);

  return (
    <Modal show={show} onHide={handleCloseModalEdit} size="lg" backdrop="static" centered>
      <Modal.Header closeButton className={isEditMode ? 'reedit-mode-wrapper' : ''}>
        <div className="col-xs-10 col-sm-6 col-md-6 col-lg-6">
          <FeatureTitleBar title={t('DisplayControlGroup.Headers.Title')}></FeatureTitleBar>
        </div>
      </Modal.Header>
      <Modal.Body className={isEditMode ? 'reedit-mode-wrapper' : ''}>
        {object && (
          <FormDetail
            object={object}
            id={Number(id)}
            handleCloseModalEdit={handleCloseModalEdit}
            dataTable={dataTable}
            setDataTable={setDataTable}
          />
        )}
      </Modal.Body>
    </Modal>
  );
};

export default Detail;
